import TableOfContent from "./component";

export default TableOfContent;